import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppNgMaterialModule } from '../app-ng-material.module';
import { SharedPipesModule } from '../shared/pipes/shared-pipe.module';
import { SharedDirectivesModule } from '../shared/_directives/shared-directives.module';
import { SharedComponentsModule } from '../shared/components/shared-components.module';
import { AddDormatComponent } from './components/add-dormat/add-dormat.component';
import { RemoveDormatComponent } from './components/remove-dormat/remove-dormat.component';

@NgModule({
  declarations: [
    AddDormatComponent,
    RemoveDormatComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppNgMaterialModule,
    SharedPipesModule,
    SharedDirectivesModule,
    SharedComponentsModule,
  ],
  exports: [
    AddDormatComponent,
    RemoveDormatComponent,
  ],
  providers: [],
})
export class ReviewModule {}
